export default function FAQSection() {
  const faqs = [
    {
      q: "非麻瓜漫画是什么类型的网站？",
      a: "非麻瓜漫画是一个专业的免费韩漫在线阅读网，我们汇集了大量最新韩国漫画资源，涵盖恋爱、奇幻、动作、剧情、搞笑、悬疑、校园、古风等多个分类。所有漫画均支持下拉式无缝观看，无需翻页，阅读体验流畅自然。",
    },
    {
      q: "非麻瓜漫画需要注册付费吗？",
      a: "完全不需要！非麻瓜漫画是一个完全免费的韩漫阅读平台。您无需注册账号、无需付费订阅，即可畅享全部漫画内容。我们致力于打破漫画阅读的壁垒，让每一位韩漫爱好者都能轻松享受高质量的漫画内容。",
    },
    {
      q: "漫画更新频率如何？",
      a: "我们拥有专业的漫画更新团队，每日紧盯韩国各大漫画平台的最新动态，确保在漫画更新的第一时间同步到非麻瓜漫画平台。大多数热门连载漫画可以做到隔日更新，部分超人气作品甚至可以实现当日同步。",
    },
    {
      q: "下拉式观看模式有什么优势？",
      a: "下拉式观看是非麻瓜漫画的核心特色之一。相比传统的翻页阅读模式，下拉式观看让您可以像刷社交媒体一样流畅地阅读漫画，无需等待页面加载，真正实现无断点的沉浸式阅读体验。特别适合在手机端阅读长篇连载漫画。",
    },
    {
      q: "漫画有广告吗？会影响阅读体验吗？",
      a: "非麻瓜漫画坚持无广告阅读体验，我们不在漫画正文中插入任何广告，确保您获得最纯净的阅读享受。我们不通过强制广告来盈利，而是希望通过优质的内容和服务赢得用户的长期支持。",
    },
    {
      q: "如何快速找到我想看的漫画？",
      a: "您可以通过首页的搜索功能（即将上线）直接搜索漫画名称或作者；也可以通过分类页面按类型浏览；我们还提供人气排行榜和热门推荐，帮助您发现最受欢迎的韩漫作品。推荐您收藏喜欢的漫画，方便随时追踪更新。",
    },
  ];

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((faq) => ({
      "@type": "Question",
      name: faq.q,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.a,
      },
    })),
  };

  return (
    <section className="bg-background-100/70 py-10 md:py-14">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-2xl font-display text-foreground-950">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 mt-2">
            关于非麻瓜漫画，您可能想知道的一切
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <details
              key={idx}
              className="group bg-background-50 rounded-xl overflow-hidden"
            >
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                <h4 className="text-sm font-medium text-foreground-900 pr-4">
                  <a id={`faq-${idx}`}></a>
                  {faq.q}
                </h4>
                <i className="ri-add-line text-foreground-400 group-open:hidden flex-shrink-0"></i>
                <i className="ri-subtract-line text-primary-500 hidden group-open:block flex-shrink-0"></i>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}